//MUI
import { Skeleton, Button, ClickAwayListener } from "@mui/material";

// Utils
import clsx from "clsx";

// SVG
import TrashIcon from "@/assets/icons/motivators/spiffSetup/trash-on-button.svg";
import { useEffect, useState } from "react";

interface ISmallActionButtonCustomProps {
	loading?: boolean;
	disabled?: boolean;
	buttonText?: string;
	buttonTextConfirm?: string;
	deleting: boolean;
	setDeleting: (value: boolean) => void;
	handleOnclick: () => void;
}

const BUTTON_ID = "confirm-delete-button-ku5ki3";
export default function SmallActionButtonCustom(props: Readonly<ISmallActionButtonCustomProps>) {
	const [widthSkeleton, setWidthSkeleton] = useState<number>(0);

	useEffect(() => {
		setTimeout(() => {
			setWidthSkeleton(document.getElementById(BUTTON_ID)?.clientWidth ?? 0);
		}, 100);
	}, [props.deleting]);

	return (
		<ClickAwayListener
			onClickAway={() => {
				if (props.deleting) {
					props.setDeleting(false);
				}
			}}
		>
			{props.loading ? (
				<Skeleton variant="rectangular" className="!rounded-[6px] !ml-[10px] !mt-[5px]" width={widthSkeleton} height={25} />
			) : (
				<Button
					id={BUTTON_ID}
					disabled={props.disabled}
					variant="contained"
					className={clsx({
						"!font-sans !text-[14.5px] !text-white !rounded-[6px] !h-[25px] !shadow-none !font-normal !normal-case": true,
						"!pb-[7px] !pt-[7px]": true,
						auto: !props.deleting,
						"!pr-[12px] !pl-[12px]": props.deleting,
						"!ml-[10px]": true,
						"!bg-gray-blue": !props.disabled,
						"!bg-disabled": props.disabled,
					})}
					onClick={() => {
						if (!props.deleting) {
							props.setDeleting(true);
						} else {
							props.handleOnclick();
						}
					}}
				>
					{!props.deleting ? props.buttonText : props.buttonTextConfirm ?? props.buttonText}
					{props.deleting && <img src={TrashIcon} alt="Remove Icon" className="ml-[11px]" />}
				</Button>
			)}
		</ClickAwayListener>
	);
}
